<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <h2 class="text-center">La Maison Group Limited<br>CMS</h2>
        </v-card-title>

        <!-- login form -->
        <v-card-text>
          <v-form 
            v-model="formValid" 
            :disabled="processing" 
            @submit.prevent="formValid && submitLogin()"
          >
            <v-text-field
              v-model="username"
              class="mb-2"
              outlined
              label="帳號"
              :rules="[v => !!v || '請輸入帳號']"
            ></v-text-field>

            <v-text-field
              v-model="password"
              outlined
              :type="isPasswordVisible ? 'text' : 'password'"
              label="密碼"
              :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              :rules="[v => !!v || '請輸入密碼']"
              @click:append="isPasswordVisible = !isPasswordVisible"
            ></v-text-field>

            <v-btn
              depressed
              :loading="processing"
              :disabled="!formValid"
              block
              elevation="0"
              color="primary"
              class="mt-6"
              type="submit"
              @click="formValid && submitLogin()"
            >
              登入
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </div>

    <v-snackbar v-model="loginError" timeout="4000" color="error" top>
      <div class="d-flex align-center">
        <v-icon class="mr-2" color="white">
          {{ icons.mdiAlertOctagon }}
        </v-icon>
        {{ errorMsg }}
      </div>
      <template #action="{ attrs }">
        <v-btn depressed color="white" icon v-bind="attrs" @click="loginError = false">
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mdiEyeOutline, mdiEyeOffOutline, mdiClose, mdiAlertOctagon } from '@mdi/js'
import { defaultPage } from '@/assets/cannotAccessList'

export default {
  name: 'Login',
  computed: {
    processing() {
      return this.$store.getters.isLoading
    }
  },
  data: () => ({
    formValid: false,
    loginError: false,
    isPasswordVisible: false,
    errorMsg: '',

    username: '',
    password: '',

    icons: {
      mdiEyeOutline,
      mdiEyeOffOutline,
      mdiClose,
      mdiAlertOctagon,
    },
  }),

  methods: {
    async submitLogin() {
      if (this.processing) {
        return;
      }

      if (!this.$validate.DataValid(this.username) || !this.$validate.DataValid(this.password)) {
        this.errorMsg = '請填滿所有必填項目';
        this.loginError = true;
        return;
      }

      this.loginError = false;
      this.$store.dispatch('setLoading', true);

      try {
        const data = await this.$Fetcher.Login(this.username, this.password);
        await this.setUserData({
          id: data.id,
          user_type: data.user_type,
          last_login: new Date().getTime(),
          username: data.username,
        })
       
        if (this.$validate.DataValid(defaultPage[data.user_type])) {
          this.$router.replace(defaultPage[data.user_type]);
        }
      } catch(err) {
        this.$common.error(err);
        this.errorMsg = err;
        this.loginError = true;
        this.$store.dispatch('setLoading', false);
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
